module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("avKJM"))).then(() => parcelRequire('d0iPb'));